export const HTTP_STATUS_CODES = {
  NOT_FOUND: 404,
  FORBIDDEN: 403,
};
